export enum KCSMBIDACustomQuestionKeys {
  CAN_COMMIT_TO_SAVING = 'canCommitToSaving',
  SEE_ANY_CHALLENGES_MEETING_SAVINGS_COMMITMENTS = 'seeAnyChallengesMeetingSavingsCommitments',
}
